import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * `<OAuthDivider />` — the "or continue with" rule above an OAuth row.
 *
 * @module
 */
import { useTranslation } from '@molecule/app-react';
import { getClassMap } from '@molecule/app-ui';
/**
 * Renders a horizontal rule with centered label text — the "or
 * continue with" divider shown between a login/signup form and the
 * OAuth button row.
 *
 * Split out as its own sub-component so the config-driven
 * `<OAuthButtons>` in `@molecule/app-auth-ui-react` can compose it
 * above `<OAuthButtons>` (the row) without re-implementing the markup.
 *
 * @param props - See `OAuthDividerProps`.
 */
export function OAuthDivider({ labelKey = 'oauth.orContinueWith', labelDefault = 'or continue with', className, } = {}) {
    const cm = getClassMap();
    const { t } = useTranslation();
    return (_jsxs("div", { className: cm.cn(cm.oauthDivider, cm.flex({ align: 'center', gap: 4 }), className), children: [_jsx("span", { className: cm.cn(cm.flex1, cm.separator()) }), _jsx("span", { children: t(labelKey, {}, { defaultValue: labelDefault }) }), _jsx("span", { className: cm.cn(cm.flex1, cm.separator()) })] }));
}
